import { createGlobalStyle } from 'styled-components';

// Styled-Components will allow us to write css as javascript and inject it on the page.
export default createGlobalStyle`
  html,
  body {
    height: 100%;
    margin: 0;
    padding: 0;
  }

  body {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  p,
  label,
  input,
  textarea {
    font-family: Georgia, Times, 'Times New Roman', serif;
    line-height: 1.5em;
  }

  #root {
    height: 100%;
    width: 100%;
    display: flex;
  }

  /* width */
  ::-webkit-scrollbar {
      width: 1rem;
  }

  /* Track */
  ::-webkit-scrollbar-track {
      background: rgba(0,0,0,0);
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: #000;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: #000;
  }
`;
